export function FormatarData({ timestamp, dateOnly = false }) {
  const date = new Date(Date.parse(timestamp));
  return dateOnly
    ? date.toLocaleDateString("pt-BR")
    : date.toLocaleString("pt-BR");
}
